import { ProductFeature } from "../types";

export function hasFeature({
    name,
    features
}: {
    features?: ProductFeature[];
    name: string;
}): boolean {
    return !!features?.some(feature => feature.featureName === name);
}
